import {HOMEMATCH_TINDER_MOTION_EASE} from "./homematch_tinder_motion";

export const SHADOW_CARD_GAP_PX = 12;

export const HOMEMATCH_TINDER_MAX_SHADOWS = 3;

export const DECK_BACKING_PADDING_TOP_BY_SHADOW_COUNT_REM = [0, 1.8, 2.8, 4] as const;

export const DECK_SHADOW_DEPTH_COLORS = ["var(--colors-gray-300)", "var(--colors-gray-200)", "var(--colors-gray-100)"] as const;

export const DECK_SHADOW_DEPTH_MOTION = [
    {opacity: 1, scale: 0.96, y: SHADOW_CARD_GAP_PX * 2},
    {opacity: 1, scale: 0.9, y: SHADOW_CARD_GAP_PX},
    {opacity: 1, scale: 0.84, y: 0}
] as const;

export const DECK_SHADOW_MOTION_EASE = HOMEMATCH_TINDER_MOTION_EASE;
import {HOMEMATCH_TINDER_MOTION_EASE} from "./homematch_tinder_motion";

export const SHADOW_CARD_GAP_PX = 12;

export const HOMEMATCH_TINDER_MAX_SHADOWS = 3;

export const DECK_BACKING_PADDING_TOP_BY_SHADOW_COUNT_REM = [0, 1.8, 2.8, 4] as const;

export const DECK_SHADOW_DEPTH_COLORS = ["var(--colors-gray-300)", "var(--colors-gray-200)", "var(--colors-gray-100)"] as const;

export const DECK_SHADOW_DEPTH_MOTION = [
    {opacity: 1, scale: 0.96, y: SHADOW_CARD_GAP_PX * 2},
    {opacity: 1, scale: 0.9, y: SHADOW_CARD_GAP_PX},
    {opacity: 1, scale: 0.84, y: 0}
] as const;

export const DECK_SHADOW_MOTION_EASE = HOMEMATCH_TINDER_MOTION_EASE;
